module.exports = __webpack_public_path__ + "img/verified.3b110ae6.png";